import Duration from "app/pages/activation/components/Shared/Duration/Duration";

import type { FirstPartyDataSource } from "../../../types/api";
import { GAConnectedPropertyInfo, type GAConnectedPropertyInfoSchema } from "../../ga-connect";
import { GA_SOURCE } from "../widgetsConfig";

type ConnectionInfoSchema = GAConnectedPropertyInfoSchema & {
    source?: FirstPartyDataSource;
    duration: string;
};

export const ConnectionInfo = ({ activationId, source, duration }: ConnectionInfoSchema) => {
    const isGA = source === GA_SOURCE;

    return (
        <>
            <Duration duration={duration} />
            {isGA ? <GAConnectedPropertyInfo activationId={activationId} /> : null}
        </>
    );
};
